module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc",
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _c('em', [_vm._v("Contents")]), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062026323_epub_itr_r1.htm",
      "id": "itr"
    }
  }, [_c('em', [_vm._v("Introduction")])]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062026323_epub_c01_r1.htm",
      "id": "c01"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER ONE")]), _c('br'), _vm._v("Cinderella"), _c('br'), _c('em', [_vm._v("Orphaned Beauty Dresses for Success, Seizes Chance for Change")])]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062026323_epub_c02_r1.htm",
      "id": "c02"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER TWO")]), _c('br'), _vm._v("The Princess and the Pea"), _c('br'), _c('em', [_vm._v("Royal Pain Snags Prince by Showing True Self")])]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062026323_epub_c03_r1.htm",
      "id": "c03"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER THREE")]), _c('br'), _vm._v("The Little Mermaid (a Tale of Warning)"), _c('br'), _c('em', [_vm._v("Aquatic Princess Drowns in Sea of Unrequited Love")])]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062026323_epub_c04_r1.htm",
      "id": "c04"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER FOUR")]), _c('br'), _vm._v("The Fairies"), _c('br'), _c('em', [_vm._v("Poor Girl with Inner Value Speaks and Grows Rich in Love")])]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062026323_epub_c05_r1.htm",
      "id": "c05"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER FIVE")]), _c('br'), _vm._v("Thumbelina"), _c('br'), _c('em', [_vm._v("Single Small Female Dates Many Frogs, Falls for Flower Fairy")])]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062026323_epub_c06_r1.htm",
      "id": "c06"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER SIX")]), _c('br'), _vm._v("Grace and Derek"), _c('br'), _c('em', [_vm._v("Betrayed Princess Learns to Trust Again")])]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062026323_epub_c07_r1.htm",
      "id": "c07"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER SEVEN")]), _c('br'), _vm._v("Beauty and the Beast"), _c('br'), _c('em', [_vm._v("Brave-Hearted Babe Sees Past Furry Face, Finds Love")])]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062026323_epub_c08_r1.htm",
      "id": "c08"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER EIGHT")]), _c('br'), _vm._v("Bluebeard (a Tale of Warning)"), _c('br'), _c('em', [_vm._v("Gold Digger Marries for Money, Nearly Digs Own Grave")])]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062026323_epub_c09_r1.htm",
      "id": "c09"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER NINE")]), _c('br'), _vm._v("The Fisherman and His Wife (a Tale of Warning)"), _c('br'), _c('em', [_vm._v("Material Girl Seeks Consumer Solution to Miserable Marriage")])]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062026323_epub_c10_r1.htm",
      "id": "c10"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER TEN")]), _c('br'), _vm._v("Sleeping Beauty"), _c('br'), _c('em', [_vm._v("One-Hundred-Sixteen-Year-Old Woman Finds Love at Last")])]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062026323_epub_app_r1.htm",
      "id": "app"
    }
  }, [_vm._v("The Fairy-tale Formula Top Ten Rules Recap")]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062026323_epub_epl_r1.htm",
      "id": "epl"
    }
  }, [_c('em', [_vm._v("Epilogue")])]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062026323_epub_ack_r1.htm",
      "id": "ack"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062026323_epub_cop_r1.htm",
      "id": "cop"
    }
  }, [_vm._v("Copyright")]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/About_the_Publisher.htm",
      "id": "pub"
    }
  }, [_vm._v("About the Publisher")]), _c('br'), _c('br'), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d27f3a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780062026323_epub_toc_r1.vue
// module id = 63
// module chunks = 0